import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import store from '@/store'
import Auth from '@/components/Auth'
import Dashboard from '@/components/Dashboard'

import BdLogin from '@/components/auth/BdLogin'
import BdQRCode from '@/components/auth/BdQRCode'
import BdRegister from '@/components/auth/BdRegister'
import BdForget from '@/components/auth/BdForget'
import BdRedirect from '@/components/auth/BdRedirect'
import BdAuthWorkWorkInternal from '@/components/auth/BdAuthWorkWorkInternal'
import BdAuthWorkWorkThird from '@/components/auth/BdAuthWorkWorkThird'

import BdChat from '@/components/dashboard/main/chat/BdChat'
import BdContact from '@/components/dashboard/main/contact/BdContact'
import BdBlock from '@/components/dashboard/main/block/BdBlock'
// import BdFavorite from '@/components/dashboard/main/favorite/BdFavorite'
import BdMonitor from '@/components/dashboard/main/monitor/BdMonitor'
import BdNotice from '@/components/dashboard/main/notice/BdNotice'
import BdOnline from '@/components/dashboard/main/online/BdOnline'
import BdQueue from '@/components/dashboard/main/queue/BdQueue'
import BdSummary from '@/components/dashboard/main/summary/BdSummary'
import BdTicket from '@/components/dashboard/main/ticket/BdTicket'
import BdTodo from '@/components/dashboard/main/todo/BdTodo'
import BdCrm from '@/components/dashboard/main/crm/BdCrm'
// import BdLeavemsg from '@/components/dashboard/main/leavemsg/BdLeavemsg'
import BdRate from '@/components/dashboard/main/rate/BdRate'
// import BdStatistic from '@/components/dashboard/main/statistic/BdStatistic'
// import BdTag from '@/components/dashboard/main/tag/BdTag'
// import BdCuw from '@/components/dashboard/main/cuw/BdCuw'
// import BdKeyword from '@/components/dashboard/main/keyword/BdKeyword'
import BdMessage from '@/components/dashboard/main/message/BdMessage'
import BdStatus from '@/components/dashboard/main/status/BdStatus'
import BdThread from '@/components/dashboard/main/thread/BdThread'
import BdFeedback from '@/components/dashboard/main/feedback/BdFeedback'
import BdQuality from '@/components/dashboard/main/quality/BdQuality'
import BdSplit from '@/components/dashboard/main/split/BdSplit'
import BdCustom from '@/components/dashboard/main/custom/BdCustom'
import BdForm from '@/components/dashboard/main/form/BdForm'
import BdRobot from '@/components/dashboard/main/robot/BdRobot'
import BdKb from '@/components/dashboard/main/kb/BdKb'
import BdWeWorkInternal from '@/components/dashboard/main/wework/internal/BdWeWorkInternal'
import BdWeWorkThird from '@/components/dashboard/main/wework/third/BdWeWorkThird'

import BdSetting from '@/components/dashboard/setting/BdSetting'
import NotFound from '@/components/common/404'

// import WeiyuAI from '@/components/dashboard/main/weiyuai/index'

const constants = require('@/util/constants')
import i18n from '@/i18n'
i18n.locale = localStorage.i18n
// const i18n = Vue.i18n

Vue.use(Router)

NProgress.configure({
  showSpinner: false,
})

// 在管理后台页面，检查是否已经登录，如果没有登录，则跳转到/login
function requireAuth(to, from, next) {
  if (!store.getters.connected) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

// 在登录界面和注册界面，检查是否已经登录，如果已经登录，则直接跳转/admin
function beforeAuth(to, from, next) {
  if (!store.getters.connected) {
    next()
  } else {
    next({
      path: '/admin',
      query: { redirect: to.fullPath }
    })
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      component: Auth,
      children: [
        {
          path: '',
          component: BdLogin,
          beforeEnter: beforeAuth,
          meta: { title: 'login' }
        },
        {
          path: 'login',
          name: 'login', // 不能注释掉，route-link中有使用
          component: BdLogin,
          beforeEnter: beforeAuth,
          meta: { title: 'login' }
        },
        {
          path: 'qrcode',
          name: 'qrcode',
          component: BdQRCode,
          beforeEnter: beforeAuth,
          meta: { title: 'qrlogin' }
        },
        {
          path: 'register',
          name: 'register',
          component: BdRegister,
          beforeEnter: beforeAuth,
          meta: { title: 'register' }
        },
        {
          path: 'forget',
          name: 'forget',
          component: BdForget,
          beforeEnter: beforeAuth,
          meta: { title: 'forget' }
        },
        {
          path: 'redirect',
          name: 'redirect',
          component: BdRedirect,
          beforeEnter: beforeAuth,
          meta: { title: 'redirect' }
        },
        {
          path: 'weworkinternalredirect',
          name: 'weworkinternalredirect',
          component: BdAuthWorkWorkInternal,
          beforeEnter: beforeAuth,
          meta: { title: 'weworkinternalredirect' }
        },
        {
          path: 'weworkthirdredirect',
          name: 'weworkthirdredirect',
          component: BdAuthWorkWorkThird,
          beforeEnter: beforeAuth,
          meta: { title: 'weworkthirdredirect' }
        },
        {
          path: '/logout',
          name: 'logout',
          beforeEnter(to, from, next) {
            store.dispatch('logout').then(() => {
              console.log('go to login page')
              next('/login')
            })
          }
        }
      ]
    },
    {
      path: '/admin',
      component: Dashboard,
      beforeEnter: requireAuth,
      children: [
        {
          path: '',
          component: BdChat,
          // meta: { title: '会话列表' }
          meta: { title: 'threads' }
        },
        {
          path: 'chat',
          name: 'chat',
          component: BdChat,
          // meta: { title: '会话列表' }
          meta: { title: 'threads' }
        },
        {
          path: 'contact',
          name: 'contact',
          component: BdContact,
          // meta: { title: '联系人' }
          meta: { title: 'contacts' }
        },
        {
          path: 'block',
          name: 'block',
          component: BdBlock,
          // meta: { title: '黑名单' }
          meta: { title: 'blockList' }
        },
        // {
        //   path: 'favorite',
        //   name: 'favorite',
        //   component: BdFavorite,
        //   // meta: { title: '我的收藏' }
        //   meta: { title: 'favorites' }
        // },
        {
          path: 'monitor',
          name: 'monitor',
          component: BdMonitor,
          // meta: { title: '监控' }
          meta: { title: 'monitors' }
        },
        {
          path: 'notice',
          name: 'notice',
          component: BdNotice,
          // meta: { title: '通知' }
          meta: { title: 'notices' }
        },
        {
          path: 'crm',
          name: 'crm',
          component: BdCrm,
          // meta: { title: '客户' }
          meta: { title: 'crm' }
        },
        // {
        //   path: 'leavemsg',
        //   name: 'leavemsg',
        //   component: BdLeavemsg,
        //   // meta: { title: '留言' }
        //   meta: { title: 'leavemsg' }
        // },
        {
          path: 'rate',
          name: 'rate',
          component: BdRate,
          // meta: { title: '满意度' }
          meta: { title: 'rate' }
        },
        // {
        //   path: 'statistic',
        //   name: 'statistic',
        //   component: BdStatistic,
        //   // meta: { title: '统计' }
        //   meta: { title: 'statistic' }
        // },
        // {
        //   path: 'tag',
        //   name: 'tag',
        //   component: BdTag,
        //   // meta: { title: '标签' }
        //   meta: { title: 'tag' }
        // },
        // {
        //   path: 'cuw',
        //   name: 'cuw',
        //   component: BdCuw,
        //   // meta: { title: '快捷回复' }
        //   meta: { title: 'cuw' }
        // },
        // {
        //   path: 'keyword',
        //   name: 'keyword',
        //   component: BdKeyword,
        //   // meta: { title: '关键词' }
        //   meta: { title: 'keyword' }
        // },
        {
          path: 'message',
          name: 'message',
          component: BdMessage,
          // meta: { title: '消息' }
          meta: { title: 'message' }
        },
        {
          path: 'statuses',
          name: 'statuses',
          component: BdStatus,
          // meta: { title: '状态' }
          meta: { title: 'status' }
        },
        {
          path: 'thread',
          name: 'thread',
          component: BdThread,
          // meta: { title: '历史会话' }
          meta: { title: 'thread' }
        },
        {
          path: 'online',
          name: 'online',
          component: BdOnline,
          // meta: { title: '在线访客' }
          meta: { title: 'onlineVisitors' }
        },
        {
          path: 'queue',
          name: 'queue',
          component: BdQueue,
          // meta: { title: '当前排队' }
          meta: { title: 'queues' }
        },
        {
          path: 'summary',
          name: 'summary',
          component: BdSummary,
          // meta: { title: '会话小结' }
          meta: { title: 'summary' }
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: BdFeedback,
          // meta: { title: '意见反馈' }
          meta: { title: 'feedback' }
        },
        {
          path: 'quality',
          name: 'quality',
          component: BdQuality,
          // meta: { title: '质量检查' }
          meta: { title: 'quality' }
        },
        {
          path: 'split',
          name: 'split',
          component: BdSplit,
          // meta: { title: '用于加载split-css' }
          meta: { title: 'split' }
        },
        {
          path: 'ticket',
          name: 'ticket',
          component: BdTicket,
          // meta: { title: '工单' }
          meta: { title: 'tickets' }
        },
        {
          path: 'todo',
          name: 'todo',
          component: BdTodo,
          // meta: { title: '待办任务' }
          meta: { title: 'todos' }
        },
        {
          path: 'custom',
          name: 'custom',
          component: BdCustom,
          // meta: { title: '自定义样式' }
          meta: { title: 'custom' }
        },
        {
          path: 'form',
          name: 'form',
          component: BdForm,
          // meta: { title: '表单' }
          meta: { title: 'form' }
        },
        {
          path: 'robot',
          name: 'robot',
          component: BdRobot,
          // meta: { title: '机器人' }
          meta: { title: 'robot' }
        },
        {
          path: 'kb',
          name: 'kb',
          component: BdKb,
          // meta: { title: '自定义样式' }
          meta: { title: 'kb' }
        },
        {
          path: 'weworkinternal',
          name: 'weworkinternal',
          component: BdWeWorkInternal,
          // meta: { title: '自定义样式' }
          meta: { title: 'weworkinternal' }
        },
        {
          path: 'weworkthird',
          name: 'weworkthird',
          component: BdWeWorkThird,
          // meta: { title: '自定义样式' }
          meta: { title: 'weworkthird' }
        },
        {
          path: 'setting',
          name: 'setting',
          component: BdSetting,
          // meta: { title: '我的设置' }
          meta: { title: 'settings' }
        },
        // {
        //   path: 'weiyuai',
        //   name: 'weiyuai',
        //   component: WeiyuAI,
        //   // meta: { title: '微语AI' }
        //   meta: { title: 'robot' }
        // }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  // console.log('beforeEach to', to)
  if (to.meta.title) {
    // document.title = to.meta.title
    document.title = i18n.t(to.meta.title) + ' - ' + (constants.FIX_TITLE ? constants.DEFAULT_TITLE : i18n.t('bytedesk'))
  }
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
